import React from "react";
import { ActionContainer, ActionContainerProps } from "../../ActionContainer";

export const PageListActionContainer = (props: ActionContainerProps) => (
    <ActionContainer
        {...props}
        margin={props.margin ?? "1rem .5rem 1rem 1rem"}
    />
);
